import { OnlyViewHoc } from 'hocs'
import React from 'react'

import { useMqrFilters } from 'hooks/useMqrFilters'
import { mqrApi } from 'redux/services/mqr'

import { AppButton } from 'components/AppButton'
import { AppFiltersLayout } from 'components/AppFiltersLayout'
import { AppSelect } from 'components/AppSelect'
import { TextField } from 'components/TextField'

import { COMMON_STATUS_TEXT } from 'constants/common'

interface Props {
  onSubmit?: () => void
  reset?: () => void
}

const defaultListValue = {
  title: 'Все',
  value: '',
}

export const Filters: React.FC<Props> = ({ onSubmit, reset }) => {
  const { params, setParam } = useMqrFilters()
  const [downloadExcel, downloadExcelState] =
    mqrApi.useDownloadMqrExcelMutation()

  const statusList = Object.entries(COMMON_STATUS_TEXT).map(
    ([value, title]) => ({
      title,
      value,
    }),
  )

  return (
    <AppFiltersLayout
      controls={
        <>
          <AppButton size="small" onClick={onSubmit}>
            Применить
          </AppButton>
          <AppButton size="small" variant="red" onClick={reset}>
            Сбросить
          </AppButton>
          <OnlyViewHoc>
            <AppButton
              onClick={() => downloadExcel(params)}
              disabled={downloadExcelState.isLoading}
              variant="siren_dashed_border"
              size="small"
            >
              Скачать Excel
            </AppButton>
          </OnlyViewHoc>
        </>
      }
    >
      <TextField
        inputSize="small"
        onChange={e => setParam('search', e.currentTarget.value)}
        value={params.search}
        name="search"
        label="Название"
        placeholder="Введите название"
      />

      <AppSelect
        size="extra_small"
        text={statusList.find(item => item.value === params.status)?.title}
        onChangeValues={value => setParam('status', value?.[0] || '')}
        list={[defaultListValue, ...statusList]}
        placeholder="Все"
        label="Статус"
      />
    </AppFiltersLayout>
  )
}
